module.exports = __webpack_public_path__ + "img/nav-logo-desktop.b2bd4a52.png";